/**
 * RESPONSIBILITY: the Visit page's "what to expect" bands.
 *
 * A list rather than three fixed blocks: the page was asked for with three, and three is
 * what it starts with, but the fourth thing a first-time visitor needs to know should be
 * a row somebody adds, not a deploy.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { VisitBand } from './rows/visit-band';

@Section({ name: SectionName.VisitExpect, label: 'Visit · What to expect' })
export class VisitExpectSection {
  @Text({ label: 'Title', maxLength: 300, default: 'What to expect' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 2000, rows: 2, description: 'Optional. Under the title.' })
  intro!: string;

  @List({
    label: 'Sections', of: () => VisitBand, maxItems: 30,
    description:
      'Each is a section down the page, built from a template you choose - a picture and its words, '
      + 'service times, a call to action, a location, questions and answers, a video, a gallery.',
  })
  bands!: VisitBand[];
}
